var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  autoinspectorApiEnums: () => autoinspectorApiEnums,
  createAutoinspectorCarDDProvider: () => createAutoinspectorCarDDProvider,
  createRavelAIProvider: () => createRavelAIProvider
});
module.exports = __toCommonJS(src_exports);
var import_openapi_fetch2 = __toESM(require("openapi-fetch"));

// src/clients/autoinspector/index.ts
var import_openapi_fetch = __toESM(require("openapi-fetch"));
var import_openapi_react_query = __toESM(require("openapi-react-query"));
var import_qs = require("qs");

// src/clients/autoinspector/authz-service/sdk.ts
var sdk_exports = {};
__export(sdk_exports, {
  constantsBuiltinRoleValues: () => constantsBuiltinRoleValues,
  constantsPolicyEffectValues: () => constantsPolicyEffectValues,
  constantsPolicyResourceValues: () => constantsPolicyResourceValues,
  constantsPolicyScopeValues: () => constantsPolicyScopeValues,
  constantsRuleActionValues: () => constantsRuleActionValues
});
var constantsBuiltinRoleValues = ["owner", "admin", "developer", "manager", "external", "view", "analyst", "member"];
var constantsPolicyEffectValues = ["EFFECT_ALLOW", "EFFECT_DENY"];
var constantsPolicyResourceValues = ["inference", "message-template", "inspection", "company", "membership", "guest", "webhook", "oauth", "invoice", "subscription", "stats", "team", "rules", "template", "theme", "signature", "secrets", "docs"];
var constantsPolicyScopeValues = ["team", "all", "own"];
var constantsRuleActionValues = ["read", "create", "update", "delete"];

// src/clients/autoinspector/billing-service/sdk.ts
var sdk_exports2 = {};
__export(sdk_exports2, {
  dtosPlanModelValues: () => dtosPlanModelValues,
  dtosPlanPeriodValues: () => dtosPlanPeriodValues,
  dtosPlanResourceValues: () => dtosPlanResourceValues,
  enumsCurrencyValues: () => enumsCurrencyValues
});
var dtosPlanModelValues = ["fixed", "metered"];
var dtosPlanPeriodValues = ["monthly", "yearly"];
var dtosPlanResourceValues = ["inspection", "template", "user"];
var enumsCurrencyValues = ["ARS", "UYU", "CHL", "USD"];

// src/clients/autoinspector/index.ts
var autoinspectorApi = (0, import_openapi_fetch.default)({
  baseUrl: process.env.NEXT_PUBLIC_API_URL,
  credentials: "include",
  querySerializer(queryParams) {
    return (0, import_qs.stringify)(queryParams);
  }
});
var hydrateRequestHeaders = (request) => {
  var _a;
  if (typeof window !== "undefined") {
    if (typeof ((_a = window.location) == null ? void 0 : _a.href) === "string") {
      request.headers.set(
        "x-current-url",
        window.location.href
      );
    }
    if (typeof window.screen !== "undefined") {
      const { height, width } = window.screen;
      if (typeof width === "number") {
        request.headers.set(
          "x-screen-width",
          String(width)
        );
      }
      if (typeof height === "number") {
        request.headers.set(
          "x-screen-height",
          String(height)
        );
      }
    }
  }
};
var clientCredentials = {
  async onRequest({ request }) {
    hydrateRequestHeaders(request);
    return request;
  }
};
autoinspectorApi.use(clientCredentials);
var $autoinspectorApi = (0, import_openapi_react_query.default)(autoinspectorApi);
var autoinspectorApiEnums = {
  billingService: sdk_exports2,
  authzService: sdk_exports
};

// src/index.ts
var createRavelAIProvider = (opts) => (0, import_openapi_fetch2.default)(opts);
var createAutoinspectorCarDDProvider = (opts) => (0, import_openapi_fetch2.default)(opts);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  autoinspectorApiEnums,
  createAutoinspectorCarDDProvider,
  createRavelAIProvider
});
